import { FiTwitter, FiFacebook, FiInstagram, FiGithub } from 'react-icons/fi';
import logo from '../../../assests/images/weblogo.png';
import { Link } from 'react-router-dom';

const links = {
    Features: ['Easy Swap', 'Buy Cryptos', 'Convert Funds', 'Send & Receive'],
    Resources: ['Blog', 'Guides', 'Support', 'FAQs'],
    Company: ['About Us', 'Careers', 'Press', 'Contact'],
    Legal: ['Privacy Policy', 'Terms of Service', 'Security', 'Compliance'],
};

function Footer() {
    return (
        <footer className="bg-[#050510] border-t border-white/5 pt-14 sm:pt-20 pb-8">
            <div className="container mx-auto px-4 sm:px-6">
                {/* Top: brand + newsletter */}
                <div className="flex flex-col lg:flex-row justify-between items-start gap-10 sm:gap-12 mb-12 sm:mb-16">
                    {/* Brand */}
                    <div className="w-full max-w-sm">
                        <div className="flex items-center gap-2 mb-4">
                            <Link to="/">
                                <img src={logo} alt="Ellipticline Logo" className="h-11 w-auto object-contain" />
                            </Link>
                        </div>
                        <p className="text-gray-500 text-sm leading-relaxed mb-6">
                            Your trusted partner in cryptocurrency trading. Fast, secure, and built for everyone.
                        </p>
                        <div className="flex items-center gap-3">
                            {[FiFacebook, FiTwitter, FiInstagram, FiGithub].map((Icon, i) => (
                                <a
                                    key={i}
                                    href="#"
                                    className="w-9 h-9 rounded-xl bg-white/5 border border-white/[0.08] flex items-center justify-center text-gray-400 hover:text-white hover:border-violet-500/50 hover:bg-violet-500/10 transition-all duration-200"
                                >
                                    <Icon size={16} />
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Newsletter */}
                    <div className="w-full lg:max-w-sm">
                        <h4 className="text-white font-bold mb-2">Stay in the loop</h4>
                        <p className="text-gray-500 text-sm mb-4">Get the latest crypto news and platform updates.</p>
                        {/* Stack vertically on mobile, row on sm+ */}
                        <div className="flex flex-col sm:flex-row gap-2">
                            <input
                                type="email"
                                placeholder="your@email.com"
                                className="w-full sm:flex-1 bg-white/5 border border-white/10 text-white placeholder-gray-600 text-sm px-4 py-3 rounded-xl focus:outline-none focus:border-violet-500/50 transition-colors"
                            />
                            <button className="w-full sm:w-auto bg-violet-600 hover:bg-violet-500 text-white font-semibold text-xs px-5 py-3 rounded-xl transition-colors whitespace-nowrap">
                                Subscribe
                            </button>
                        </div>
                    </div>
                </div>

                {/* Link columns */}
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 pb-12 sm:pb-16 border-b border-white/5">
                    {Object.entries(links).map(([col, items]) => (
                        <div key={col}>
                            <h4 className="text-white font-bold text-sm mb-4 sm:mb-5">{col}</h4>
                            <ul className="space-y-2 sm:space-y-3">
                                {items.map((item) => (
                                    <li key={item}>
                                        <a
                                            href="#"
                                            className="text-gray-500 hover:text-gray-300 text-sm transition-colors"
                                        >
                                            {item}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                {/* Bottom bar */}
                <div className="flex flex-col justify-between items-center gap-3 pt-8">
                    <p className="text-gray-600 text-sm">© 2026 Ellipticline. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;